<div class="text-center">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
    </div>
</div>
<div class="text-center">
    <label>Procesando...</label>
</div>